import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Высота элемента в px с обновлением при изменении размера — для отступа контента
 * под фиксированными шапкой и нижней панелью мобильной оболочки.
 */
export function useElementHeight<T extends HTMLElement>(fallbackPx: number) {
  const ref = useRef<T | null>(null);
  const [height, setHeight] = useState(fallbackPx);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setHeight(el.getBoundingClientRect().height || fallbackPx);
    update();
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [fallbackPx]);

  return { ref, height };
}
